<template>
  <div class="liste-competences--flex">
    <choix-competence v-for="(competence, index) in competences" :key="index" :callback="callback" :competence="competence"/>
  </div>
</template>

<script>
import ChoixCompetence from './ChoixCompetence';

export default {
  name: 'choix-competence-repeater',
  components: {ChoixCompetence},
  props: [
    'competences', 'callback'
  ]
}
</script>

<style scoped>
#appcompetences--widget .liste-competences--flex {
  display: flex;
  flex-wrap: wrap;
}
</style>
